import './assets/main.css'
import './assets/toast.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ToastPlugin from 'vue-toast-notification'

import App from './App.vue'
import router from './router'

if (import.meta.env.DEV) {
  document.title = `GAE Conseil (dev)`
}

const app = createApp(App)

app.use(ToastPlugin, {
  position: 'top'
})
app.use(createPinia())
app.use(router)

app.mount('#app')
